/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';

function UserIcon(props, svgRef) {
  return React.createElement("svg", Object.assign({
    "data-sanity-icon": "user",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), React.createElement("path", {
    d: "M8 14.5C7 15 5.5 16 5.5 19.5H19.5C19.5 16 18.3416 15.1708 17 14.5C16 14 14 14 14 12.5C14 11 15 10.25 15 8.25C15 6.25 14 5.25 12.5 5.25C11 5.25 10 6.25 10 8.25C10 10.25 11 11 11 12.5C11 14 9 14 8 14.5Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  }));
}

var ForwardRef = React.forwardRef(UserIcon);
export default ForwardRef;